module.exports = __webpack_public_path__ + "static/ergul-web-0231143e98c25ef268fc1e028d1b0552.jpg";